import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import HihglightsPanelComponent from './js/highlights-panel.component';
import HighlightsPanelLayout from './js/highlights-panel-layout';
import HighlightsPanel from './js/highlights-panel';

ComponentsFactory.getInstance().define('highlights-panel', HihglightsPanelComponent);

export {
    HighlightsPanelLayout,
    HighlightsPanel,
};
